import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

function Trash({ width = 20, height = 20, className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23 1.75H9.12c-.513 0-.962-.002-1.363.156a2.25 2.25 0 00-.903.65c-.276.331-.418.758-.58 1.245l-.034.103-.115.346H2.5a.75.75 0 000 1.5h.965l.488 7.32.002.03c.05.763.092 1.38.165 1.879.076.514.193.964.428 1.377a3.75 3.75 0 001.623 1.519c.428.207.885.294 1.403.335.503.04 1.121.04 1.886.04h1.08c.765 0 1.383 0 1.886-.04.518-.041.975-.128 1.403-.335a3.75 3.75 0 001.623-1.519c.235-.413.352-.863.428-1.378.073-.498.114-1.115.165-1.878l.002-.03.488-7.32h.965a.75.75 0 000-1.5h-3.627l-.114-.346-.035-.103c-.161-.487-.303-.914-.58-1.244a2.25 2.25 0 00-.902-.65c-.4-.159-.85-.158-1.363-.157H9.23zm4.086 4H15.03l-.48 7.22c-.054.8-.092 1.357-.155 1.79-.063.425-.142.669-.248.854a2.25 2.25 0 01-.973.91c-.192.094-.44.157-.868.19-.436.035-.995.036-1.798.036H9.491c-.803 0-1.362 0-1.798-.035-.427-.034-.676-.097-.868-.19a2.25 2.25 0 01-.973-.911c-.106-.185-.185-.43-.248-.853-.063-.433-.101-.99-.154-1.792L4.968 5.75H13.316zm-1.023-1.5c-.182-.54-.234-.654-.299-.731a.75.75 0 00-.3-.217c-.1-.04-.238-.052-.924-.052H9.23c-.686 0-.823.013-.923.052a.75.75 0 00-.301.217c-.065.077-.117.191-.299.731h4.586zm-3.21 4.083a.75.75 0 10-1.5 0v5.834a.75.75 0 001.5 0V8.333zm2.584-.75a.75.75 0 01.75.75v3.334a.75.75 0 01-1.5 0V8.333a.75.75 0 01.75-.75z"
        fill="#656565"
      />
    </svg>
  );
}

export default Trash;
